import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_REMOVE_DROP_OUTS_BEGIN,
  MANAGE_SUBS_REMOVE_DROP_OUTS_SUCCESS,
  MANAGE_SUBS_REMOVE_DROP_OUTS_FAILURE,
  MANAGE_SUBS_REMOVE_DROP_OUTS_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';
export function removeDropOuts(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_REMOVE_DROP_OUTS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.post(`${API_REQUEST_URL}/removeDropOuts`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          const data = res.data;
          dispatch({
            type: MANAGE_SUBS_REMOVE_DROP_OUTS_SUCCESS,
            data: data,
          });
          resolve(data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_REMOVE_DROP_OUTS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissRemoveDropOutsError() {
  return {
    type: MANAGE_SUBS_REMOVE_DROP_OUTS_DISMISS_ERROR,
  };
}

export function useRemoveDropOuts() {
  const dispatch = useDispatch();

  const { removeDropOutsPending, removeDropOutsError } = useSelector(
    state => ({
      removeDropOutsPending: state.manageSubs.removeDropOutsPending,
      removeDropOutsError: state.manageSubs.removeDropOutsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(removeDropOuts(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissRemoveDropOutsError());
  }, [dispatch]);

  return {
    removeDropOuts: boundAction,
    removeDropOutsPending,
    removeDropOutsError,
    dismissRemoveDropOutsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_REMOVE_DROP_OUTS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeDropOutsPending: true,
        removeDropOutsError: null,
      };

    case MANAGE_SUBS_REMOVE_DROP_OUTS_SUCCESS:
      // The request is success
      return {
        ...state,
        removeDropOutsPending: false,
        removeDropOutsError: null,
      };

    case MANAGE_SUBS_REMOVE_DROP_OUTS_FAILURE:
      // The request is failed
      return {
        ...state,
        removeDropOutsPending: false,
        removeDropOutsError: action.data.error,
      };

    case MANAGE_SUBS_REMOVE_DROP_OUTS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeDropOutsError: null,
      };

    default:
      return state;
  }
}
